export const iconFontAwesomeHumanitarianHammer = (
	<i className="fa-solid fa-hammer"></i>
);
